import styled from 'styled-components';

export const CardButton = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  text-align: left;
  padding: 0.85rem 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
    background: ${({ theme }) => `${theme.colors.primary}06`};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const CardMain = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

export const StarIcon = styled.span`
  flex-shrink: 0;
  color: #d97706;
  font-size: 0.9rem;
  line-height: 1;
`;

export const CardTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
`;

export const CardTitle = styled.span`
  font-size: 0.92rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1.3;
`;

export const CardDescription = styled.span`
  font-size: 0.8rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.text.secondary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.15rem;
`;

export const MetaBadge = styled.span`
  font-size: 0.68rem;
  font-weight: 600;
  padding: 0.12rem 0.45rem;
  border-radius: 999px;
  color: #155e75;
  background: #ecfeff;
  border: 1px solid #a5f3fc;
`;

export const StepBadge = styled(MetaBadge)`
  color: ${({ theme }) => theme.colors.text.secondary};
  background: ${({ theme }) => theme.colors.background};
  border-color: ${({ theme }) => theme.colors.border.light};
`;

export const CardActions = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  gap: 0.25rem;
  margin-top: 0.1rem;
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background: transparent;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  transition:
    color 0.15s ease,
    background 0.15s ease;

  &:hover:not(:disabled) {
    color: #b91c1c;
    background: #fef2f2;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;

export const CardChevron = styled.span`
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  line-height: 1;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
